import {RouteRecordRaw} from "vue-router";
import Lista from "../pages/tokens/Tokens.vue";
import FormularioTokens from "../pages/tokens/FormularioTokens.vue";

export const Tokens: RouteRecordRaw[] = [
    {name: 'tokens', path: '/tokens', meta: {title: 'Gestión de tokens'}, component: Lista},
    {name: 'tokens.nueva', path: '/tokens/nuevo', meta: {title: 'Nuevo token'}, component: FormularioTokens},
    {name: 'tokens.editar', path: '/tokens/:id', meta: {title: 'Editar token'}, component: FormularioTokens},
];